export function setDisconnectsLoading (state, loading = false) {
  state.disconnectsLoading = loading
}

export function setDisconnects (state, disconnects) {
  state.disconnects = disconnects.data
  state.disconnectsCurrentPage = disconnects.current_page
  state.disconnectsLastPage = disconnects.last_page
  state.disconnectsPerPage = disconnects.per_page
  state.disconnectsTotal = disconnects.total
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}
